import { TIconType } from './components/atoms/Icon'
import getEnvVars from './environment'
import marketingCopy from './marketingCopy'
import { TIconColor } from './styles/colors'
import { icons } from './styles/images'
import { tokens } from './styles/tokens'

export const { REACT_APP_API_BASE_URL, REACT_APP_FRONTEND_BASE_URL, COOKIE_DOMAIN } = getEnvVars()

// API Constants
export const TASK_FOLDER_DEFAULT_ID = '-1'
export const AUTHORIZATION_COOKE = 'authToken'

// Time constants (in milliseconds)
export const BACKFILL_RECURRING_TASKS_INTERVAL = 5 * 60 * 1000
export const DETAILS_SYNC_TIMEOUT = 1 * 1000
export const DRAG_TASK_TO_OPEN_CALENDAR_TIMEOUT = 0.5 * 1000
export const EVENT_UNDO_TIMEOUT = 5 * 1000
export const EVENTS_REFETCH_INTERVAL = 60 * 1000
export const ONE_MINUTE_INTERVAL = 60 * 1000
export const FIVE_MINUTE_INTERVAL = 5 * 60 * 1000
export const FIFTEEN_MINUTE_INTERVAL = 15 * 60 * 1000
export const FIVE_SECOND_TIMEOUT = 5 * 1000
export const NOTE_SYNC_TIMEOUT = 1 * 1000
export const QUEUED_MUTATION_DEBOUNCE = 1 * 1000
export const SINGLE_SECOND_INTERVAL = 1000
export const TASK_MARK_AS_DONE_TIMEOUT = parseInt(tokens.motion.complete, 10) // the row's fade and close, styles/motion.ts
export const TASK_REFETCH_INTERVAL = 60 * 1000
export const TIME_INDICATOR_INTERVAL = 6 * 1000
export const DEFAULT_BACKGROUND_QUERY_STALE_TIME = 15 * 1000

// Backend Endpoints
export const TASKS_URL = REACT_APP_API_BASE_URL + '/tasks/'
export const TASKS_MODIFY_URL = REACT_APP_API_BASE_URL + '/tasks/modify/'
export const TASKS_CREATE_URL = REACT_APP_API_BASE_URL + '/tasks/create/'
export const LOGIN_URL = REACT_APP_API_BASE_URL + '/login/'
export const DEEPLINK_LOGIN_URL = LOGIN_URL + '?use_deeplink=true'
export const LOGOUT_URL = REACT_APP_API_BASE_URL + '/logout/'
export const SETTINGS_URL = REACT_APP_API_BASE_URL + '/settings/'
export const LINKED_ACCOUNTS_URL = REACT_APP_API_BASE_URL + '/linked_accounts/'
export const SUPPORTED_TYPES_URL = REACT_APP_API_BASE_URL + '/linked_accounts/supported_types/'
export const LOG_EVENTS_URL = REACT_APP_API_BASE_URL + '/log_events/'
export const EVENTS_URL = REACT_APP_API_BASE_URL + '/events/'

// Routes
export const TERMS_OF_SERVICE_ROUTE = 'terms-of-service'
export const PRIVACY_POLICY_ROUTE = 'privacy-policy'
export const FOCUS_MODE_ROUTE = 'focus-mode'
export const LEGACY_SHARING_ROUTES: readonly string[] = ['note', 'task']
export const GOOGLE_AUTH_ROUTE = 'link/google'

export const LEGAL_COPYRIGHT_NOTICE = '© 2026 JOHNGLOMERATE LIMITED'

export const NO_TITLE = '(no title)'
export const EMPTY_MONGO_OBJECT_ID = '000000000000000000000000'
export const DEFAULT_FOLDER_ID = '000000000000000000000001'
export const DONE_FOLDER_ID = '000000000000000000000004'
export const TRASH_FOLDER_ID = '000000000000000000000005'

export const TASK_INBOX_NAME = 'Task Inbox'
export const TRASH_FOLDER_NAME = 'Trash'
export const DONE_FOLDER_NAME = 'Done'

export interface TTaskPriority {
    icon: TIconType
    label: string
    color: TIconColor
}
export const TASK_PRIORITIES: TTaskPriority[] = [
    { icon: icons.priority_none, label: 'No priority', color: 'black' },
    { icon: icons.priority_urgent, label: 'Urgent priority', color: 'red' },
    { icon: icons.priority_high, label: 'High priority', color: 'yellow' },
    { icon: icons.priority_medium, label: 'Medium priority', color: 'blue' },
    { icon: icons.priority_low, label: 'Low priority', color: 'green' },
]

export const GOOGLE_CALENDAR_SUPPORTED_TYPE_NAME = 'Google Calendar'
export const GENERAL_TASK_SOURCE_NAME = 'General Task'
export const SUBSCRIPTION_PRICE = marketingCopy.SUBSCRIPTION_PRICE
export const SUBSCRIPTION_PRICE_A_MONTH = marketingCopy.SUBSCRIPTION_PRICE_A_MONTH
export const SUBSCRIPTION_TRIAL_DAYS = marketingCopy.SUBSCRIPTION_TRIAL_DAYS
export const SUBSCRIPTION_TRIAL_OFFER = marketingCopy.SUBSCRIPTION_TRIAL_OFFER
export const TRIAL_NUDGE_DAYS = 3

export const SYNC_MESSAGES = {
    SYNCING: 'Syncing...',
    ERROR: 'There was an error syncing with our servers',
    COMPLETE: '',
}
